import { node, icon } from "~/util/dom";
import { TDebugColors } from "./interfaces";

interface IRibbonUp {
	debug?: boolean;
}

export default class RibbonUp {
	_options: IRibbonUp;

	_dom: {[key: string]: HTMLElement};

	_onClick: () => void;

	_wasInfo: boolean;

	constructor(opts: IRibbonUp) {
		this._options = {
			debug: false,
			...opts,
		};
		this._onClick = () => {};
		this._dom = {};
		this._wasInfo = false;

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	set debugTitle(title: string) {
		if (this._options.debug) {
			this._dom.container.title = title;
		}
	}

	hide() {
		this._dom.container.classList.add("hide");
	}

	show() {
		this._dom.container.classList.remove("hide");
	}

	debugColor(color?: TDebugColors) {
		if (color && this._options.debug) {
			this._dom.container.setAttribute("data-color", color);
		} else {
			this._dom.container.removeAttribute("data-color");
		}
	}

	onClick(onClick: () => void) {
		this._onClick = onClick;
	}

	_build() {
		const svgBtnRibbonUp = node("button", { type: "button", className: "ribbon__btnUp" });

		svgBtnRibbonUp.append(icon("ribbon-button-up-cover"));
		svgBtnRibbonUp.append(icon("ribbon-button-up"));
		svgBtnRibbonUp.addEventListener("click", () => {
			this._onClick();
		});

		this._dom.container = svgBtnRibbonUp;
	}
}
